function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function preprocessTexts(initialText, finalText) {
  if (initialText.length === finalText.length) {
    return [initialText, finalText]; // No preprocessing needed
  }

  const maxLength = Math.max(initialText.length, finalText.length);
  const paddedInitialText = initialText.padEnd(maxLength);
  const paddedFinalText = finalText.padEnd(maxLength);

  return [paddedInitialText, paddedFinalText];
}

function transformText(initialText, finalText) {
  return new Promise(resolve => {
    const outputDiv = document.getElementById('output');
    const [processedInitialText, processedFinalText] = preprocessTexts(initialText, finalText);

    const initialArray = processedInitialText.split('');
    const finalArray = processedFinalText.split('');
    const transformOrder = [...Array(initialArray.length).keys()];

    shuffle(transformOrder);

    let index = 0;
    let direction = 1;

    const transformInterval = setInterval(() => {
      if (index < 0 || index >= transformOrder.length) {
        direction *= -1;
        shuffle(transformOrder);
      }

      const currentIndex = transformOrder[index];
      initialArray[currentIndex] = (direction === 1) ? finalArray[currentIndex] : processedInitialText[currentIndex];
      outputDiv.textContent = initialArray.join('');

      index += direction;

      if (index === transformOrder.length && direction === 1) {
        clearInterval(transformInterval);
        setTimeout(() => {
          resolve(); // Resolve the promise to signal completion of transformation
        }, 3000);
      }
    }, 100); // Adjust speed of transformation here (in milliseconds)
  });
}

async function animateTextTransformation() {
  const initialTexts = [" Regenerative  ", "Women's", "Vaginal", "Sexual"]; // Array of initial texts
  const finalTexts = ["Vaginal", "Sexual", " Regenerative  ", "Women's"]; // Array of final texts
  let currentIndex = 0;

  while (true) {
    const initialText = initialTexts[currentIndex];
    const finalText = finalTexts[currentIndex];

    await transformText(initialText, finalText);

    currentIndex++;
    if (currentIndex === initialTexts.length) {
      currentIndex = 0; // Reset index to loop back to the start
    }
  }
}

// Example usage
animateTextTransformation();
